import { createSlice } from '@reduxjs/toolkit'

const produtoInicial = {  
    uCom: "UN",
    vUnCom: "",
    markup: 0,
    uTrib: "",
    enviaBalanca: 0,
    origem: "0",
    imprimeDataValidade: 1,
    transformacaoVunTribAutomatica: true,
    fatorCorrecaoUnidadeMedidaTrib: 1,
    imprimeDataEmbalagem: 1,
    publicaEcommerce:"NAO", 
    estoqueEcommerce: "EM_ESTOQUE",
    tipoProduto: "SIMPLES",
    cEnqIPI: "999",
    exibeNucardapio: 1,
    sincronizado: 0,
    composicao: [],
    imprimeItemComanda: "SIM",
    numeroImpressoraComanda: 1,
    exibeProdutoPDV: "SIM",
    
}

const ReducerProduto = createSlice({
    
    name: "Produto",
    initialState: {
        produto: produtoInicial,
        firstErrorField: ''
    },
    reducers: {
        atualizaProduto: (state, {payload:produto})=> {
            state.produto = Object.assign({}, state.produto, produto);
        },

        atualizaFirstErrorField: (state, {payload}) => {
            state.firstErrorField = payload;
        }

      
        
                
    }
})


export const { atualizaFirstErrorField, atualizaProduto } = ReducerProduto.actions

export const dadosPadraoProduto = produtoInicial;

export default ReducerProduto.reducer